<template>
  <div>
    <ProgressBar :steps="processBarItems" :setCurrent="processBarIndex - 1" />
    <div id="processBar" class="flex justify-between" v-if="false">
      <div
        v-for="(item, index) in processBarItems"
        v-bind:key="index"
        :class="[
          'flex flex-col items-center w-full mt-12 md:mt-8 mb-4 md:mb-0 justify-center',
          index % 2 == 0 ? '' : 'justify-center',
        ]"
      >
        <div
          v-if="index % 2 == 0"
          class="items-center content-center flex flex-col"
        >
          <div
            :class="[
              'rounded-full h-8 w-8 flex items-center justify-center border',
              processBarCurrentItem > index + 1
                ? /* theme.processBar.itemDoneBackgroundColor*/ 'bg-primary-100'
                : processBarCurrentItem === index + 1
                ? /* theme.processBar.currentItemBackgroundColor */ 'bg-primary-300'
                : /* theme.processBar.futureItemBackgroundColor*/ 'bg-primary-100',
            ]"
            :style="
              processBarCurrentItem > index + 1
                ? stepsBackground
                : processBarCurrentItem === index + 1
                ? stepsActiveBackground
                : stepsBackground
            "
          >
            <div
              :class="[
                processBarCurrentItem >= index
                  ? 'text-white'
                  : /* theme.processBar.futureItemTextColor */ 'text-white',
              ]"
              :style="
                processBarCurrentItem >= index ? stepsActiveNumber : stepsNumber
              "
            >
              {{ item.number }}
            </div>
          </div>
          <div class="flex flex-row justify-around text-center mt-2">
            <p
              :class="[
                'text-xs w-14 break-words h-8',
                processBarCurrentItem > index + 1
                  ? /* theme.processBar.itemDoneTextColor */ 'hidden'
                  : processBarCurrentItem === index + 1
                  ? /* theme.processBar.currentItemTextColor*/ 'text-new-primary font-bold'
                  : /* theme.processBar.futureItemBottomTextColor*/ 'hidden',
              ]"
              :style="stepsActiveText"
            >
              {{ lang[item.text][language] }}
            </p>
          </div>
        </div>
        <div
          v-else
          :class="[
            'border-t-2 w-full',
            processBarCurrentItem > index + 1
              ? ''
              : processBarCurrentItem === index + 1
              ? 'border-blue-800'
              : 'border-gray-500',
          ]"
        >
          <!--Border between the processbarItems -->
          <div>
            <p class="text-white md:text-gray-300"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ProgressBar from "../components/ProgressBar.vue";
import lang from "../lang";

export default {
  computed: {
    ...mapGetters([
      "hasKiosk",
      "menu",
      "theme",
      "language",
      "processBarCurrentItem",
      "processBarIndex",
    ]),

    ...mapGetters("Cart", [
      "stickerId",
      "tableId",
    ]),
    ...mapGetters("Theme", [
      "stepsActiveText",
      "stepsActiveBackground",
      "stepsNumber",
      "stepsActiveNumber",
      "stepsBackground",
    ]),
    processBarCurrentItem: {
      get() {
        if (this.$route.name == "payment") {
          this.$store.commit("updateProcessBarCurrentItem", 7);
        }
        return this.$store.getters["processBarCurrentItem"];
      },
    },
  },
  components: {
    ProgressBar,
  },
  data() {
    return {
      lang: lang,
      processBarItems: [],
    };
  },
  mounted() {
    // this number is the count of steps we are going to see in the cart (max: 4, min: 2)
    let number = 1;
    // this step is always here for the overview of the items in the cart
    this.processBarItems = [{ text: "select_items", number: number++, id: 1 }];
    // if it is takeout add a step else if it is table mode add a step
    if (
      this.menu.pos_mode == "take-out" &&
      (this.menu.timeslots_mode == "general" ||
        this.menu.timeslots_mode == "individual")
    ) {
      this.processBarItems.push({ text: "" });
      this.processBarItems.push({
        text: "Time",
        number: number++,
        id: 2,
      });
    } else {
      if (
        (this.stickerId == 0 ||
        this.tableId == null) &&
          this.menu.pos_mode == "table" ||
        (this.stickerId == 0 ||
        this.tableId == null) &&
        this.menu.pos_mode == "table-manual"
      ) {
        this.processBarItems.push({ text: "" });
        this.processBarItems.push({
          text: "table",
          number: number++,
          id: 3,
        });
      }
    }
    // if we need to show contact details or if it is take-out mode, add the step
    // If the mode is kiosk and both phone and name labels are disabled then don't add the user details step
    if(this.hasKiosk ? this.menu.is_checkout_name_enabled || this.menu.show_phone_number : true)
    if (
      !this.menu.customer_details_disabled ||
      this.menu.pos_mode == "take-out"
    ) {
      this.processBarItems.push({ text: "" });
      this.processBarItems.push({
        text: "contact_details",
        number: number++,
        id: 4,
      });
    }

    // the last step is always the payment methods so we show this step always
    this.processBarItems.push({ text: "" });
    this.processBarItems.push({
      text: "payment",
      number: number++,
      id: 4,
    });
  },
};
</script>
